export function initVideoControls(videos, id = false) {
  const PAUSE_ICON = '<svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none"><path d="M10.625 0.875V9.625C10.625 9.85706 10.5328 10.0796 10.3687 10.2437C10.2046 10.4078 9.98206 10.5 9.75 10.5H7.5625C7.33044 10.5 7.10788 10.4078 6.94378 10.2437C6.77969 10.0796 6.6875 9.85706 6.6875 9.625V0.875C6.6875 0.642936 6.77969 0.420376 6.94378 0.256282C7.10788 0.0921872 7.33044 0 7.5625 0H9.75C9.98206 0 10.2046 0.0921872 10.3687 0.256282C10.5328 0.420376 10.625 0.642936 10.625 0.875ZM3.0625 0H0.875C0.642936 0 0.420376 0.0921872 0.256282 0.256282C0.0921872 0.420376 0 0.642936 0 0.875V9.625C0 9.85706 0.0921872 10.0796 0.256282 10.2437C0.420376 10.4078 0.642936 10.5 0.875 10.5H3.0625C3.29456 10.5 3.51712 10.4078 3.68122 10.2437C3.84531 10.0796 3.9375 9.85706 3.9375 9.625V0.875C3.9375 0.642936 3.84531 0.420376 3.68122 0.256282C3.51712 0.0921872 3.29456 0 3.0625 0Z" fill="white"/></svg>';
  const PLAY_ICON = '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12" fill="none"><path d="M9.625 5.68777C9.62536 5.83632 9.58727 5.98243 9.51444 6.1119C9.44161 6.24136 9.33652 6.34978 9.20938 6.4266L1.33 11.2468C1.19716 11.3281 1.04501 11.3725 0.889261 11.3754C0.733517 11.3783 0.579827 11.3395 0.444063 11.2632C0.309591 11.188 0.197573 11.0783 0.119527 10.9455C0.0414813 10.8127 0.000224688 10.6614 0 10.5074V0.868164C0.000224688 0.714101 0.0414813 0.562878 0.119527 0.430046C0.197573 0.297215 0.309591 0.187568 0.444063 0.112382C0.579827 0.0360104 0.733517 -0.00273412 0.889261 0.000150033C1.04501 0.00303418 1.19716 0.0474425 1.33 0.128789L9.20938 4.94894C9.33652 5.02577 9.44161 5.13418 9.51444 5.26365Q9.58727 5.39312 9.625 5.68777Z" fill="white"/></svg>';

  videos.forEach((video, index) => {
    if (video.closest('.video-wrapper-accessible')) return;

    if (video.hasAttribute('controls') && video.hasAttribute('autoplay')) {
      video.removeAttribute('controls');
    }

    if (!video.id) {
      // eslint-disable-next-line
      video.id = `accessible-video-${id ?? index}`;
    }

    const computedStyle = window.getComputedStyle(video);
    const isAbsolute = computedStyle.position === 'absolute';
    const isHero = video.classList.contains('hero__video-background')
      || video.id === 'hero-background-video'
      || video.closest('.hero__video-background-outer');
    const wrapper = document.createElement('div');
    wrapper.className = 'video-wrapper-accessible';

    if (isHero) {
      wrapper.classList.add('video-wrapper-accessible--hero');
      const slideParent = video.closest('.hero__slide-outer') || video.closest('.swiper-slide');

      if (slideParent) {
        slideParent.classList.add('hero-slide-accessible-video');
      }
    } else if (isAbsolute) {
      wrapper.classList.add('video-wrapper-accessible--absolute');
    }

    video.parentNode.insertBefore(wrapper, video);
    wrapper.appendChild(video);
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'video-pause-control';
    btn.setAttribute('aria-label', 'Pause video');
    btn.setAttribute('aria-controls', video.id);
    btn.setAttribute('aria-pressed', 'true');
    btn.innerHTML = `<span class="video-pause-control__icon">${PAUSE_ICON}</span>`;
    wrapper.appendChild(btn);
    btn.addEventListener('click', () => {
      const iconContainer = btn.querySelector('.video-pause-control__icon');

      if (video.paused) {
        video.play();
        btn.setAttribute('aria-label', 'Pause video');
        btn.setAttribute('aria-pressed', 'true');
        iconContainer.innerHTML = PAUSE_ICON;
      } else {
        video.pause();
        btn.setAttribute('aria-label', 'Play video');
        btn.setAttribute('aria-pressed', 'false');
        iconContainer.innerHTML = PLAY_ICON;
      }
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    const videos = document.querySelectorAll('video[autoplay]');
    initVideoControls(videos);
  });
} else {
  const videos = document.querySelectorAll('video[autoplay]');
  initVideoControls(videos);
}
